/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    fetchUserInfoErrorAction,
    fetchUserInfoSuccessAction,
    SettingsUserInfoAction,
    SettingsUserInfoActionType,
} from '../actions/settingsUserInfoActions';
import { usersClient } from '../api/users/usersClient';

export const fetchUserInfoEpic: Epic<SettingsUserInfoAction> = (action$, state) => {
    return action$.pipe(
        ofType(SettingsUserInfoActionType.OPEN_SETTINGS_USER_INFO_PAGE),
        switchMap(() => {
            const userId = state.value.userReducer.authData.userId;

            return from(usersClient.getDetailedUser(userId)).pipe(
                map((resp) => fetchUserInfoSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchUserInfoErrorAction(
                            parseError(err, i18n.t('SystemScreens.errors.userInfoNotFound', { searchText: userId })),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(SettingsUserInfoActionType.EXIT_SETTINGS_USER_INFO_PAGE))),
            );
        }),
    );
};

export const updateUserInfoEpic: Epic<SettingsUserInfoAction> = (action$) => {
    return action$.pipe(
        ofType(SettingsUserInfoActionType.UPDATE_USER_INFO),
        switchMap((action) => {
            return from(usersClient.updateUserProfile(action.payload)).pipe(
                map((resp) => fetchUserInfoSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchUserInfoErrorAction(
                            parseError(err, i18n.t('SystemScreens.errors.updateUserInfoFailed'), true),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(SettingsUserInfoActionType.EXIT_SETTINGS_USER_INFO_PAGE))),
            );
        }),
    );
};
